export const FILE_UPLOAD_MAX_SIZE = 25000000;

export const ZENCAM_ERROR_CODES = {
    standard_error: 1000,
    file_size_too_large_error: 1001
};

/**
 * Cordova plugins don't have a consistent location, so this module provides that for us.
 * Each key is a 1:1 reference to the name of the Cordova plugin as it would be referenced
 * otherwise.
 */
export const CordovaPlugins = () => {
    if (!window.cordova) {
        return {};
    }

    return {
        BuildInfo: window.BuildInfo,
        device: window.device,
        clipboard: cordova.plugins.clipboard,
        connection: window.navigator.connection,
        screen: window.screen,
        barcodeScanner: cordova.plugins.barcodeScanner,
        Keyboard: cordova.plugins.Keyboard,
        camera: navigator.camera,
        CameraPopoverOptions: window.CameraPopoverOptions,
        actionsheet: window.plugins.actionsheet,
        pushwoosh: cordova.require('pushwoosh-cordova-plugin.PushNotification'),
        media_capture: navigator.device.capture,
        splashscreen: navigator.splashscreen,
        SyncStatus: window.SyncStatus,
        notification: navigator.notification,
        file: cordova.file,
        NativeStorage: window.NativeStorage,
        resolveLocalFileSystemURL: window.resolveLocalFileSystemURL,
        globalization: navigator.globalization,
        zencam: cordova.zencam,
        bluetoothle: window.bluetoothle,
        sqlitePlugin: window.sqlitePlugin,
        InAppBrowser: cordova.InAppBrowser,
        UserAgent: window.UserAgent
    };
};

export const getZencamLocalizedStrings = () => ({
    delete_photo: _t('mobile_message_image_confirm_remove_image'),
    download: _t('mobile_dialog_benefits_button_download'),
    save: _t('mobile_common_button_save'),
    done: _t('mobile_common_button_done'),
    retake: _t('mobile_common_button_retake'),
    no: _t('mobile_common_button_no'),
    yes: _t('mobile_common_button_yes'),
    share: _t('mobile_zencam_share'),
    cancel: _t('mobile_action_sheet_cancel')
});
